// --------------------------------------------------------------------------
// megaNav.js
// --------------------------------------------------------------------------
// The dropdowns for the mega nav
// --------------------------------------------------------------------------

RN.megaNav = function() {

  'use strict';

  var siteNav = byElement('site-nav'),
    activeClass = 'mega-nav--is-active';

  function init() {
    var trueHover = RN.trueHover.getTrueHover(),
        megaNavLinks = byBehaviour('mega-nav');

    if(trueHover && window.matchMedia("(min-width: 1181px)").matches){
      megaNavLinks.on('click', function(){
        return false;
      });
    }
    else {
      megaNavLinks.on('click', showMegaNav);
      byBehaviour('mega-nav-back').on('click', hideMegaNav);
    }
  }

  function showMegaNav() {
    var self = $(this);
    $('.' + activeClass).removeClass(activeClass);
    self.next().addClass(activeClass);
    siteNav.addClass('site-nav--show-subs');
    return false;
  }

  function hideMegaNav() {
    $('.' + activeClass).removeClass(activeClass);
    siteNav.removeClass('site-nav--show-subs');
    return false;
  }

  return {
    init: init
  };

}();